import { render, staticRenderFns } from "./navbar-component.vue?vue&type=template&id=5187c434&scoped=true&"
import script from "./navbar-component.vue?vue&type=script&lang=js&"
export * from "./navbar-component.vue?vue&type=script&lang=js&"
import style0 from "./navbar-component.vue?vue&type=style&index=0&id=5187c434&scoped=true&lang=css&"
import style1 from "./navbar-component.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5187c434",
  null
  
)

export default component.exports